import { createModel } from '@rematch/core';
import { get, post } from 'utils/http';

export default createModel()({
  state: {},
  reducers: {
    setState: (state: any, payload: any) => ({ ...state, ...payload }),
  },
  effects: {
    setReduxData({ key, data }) {
      this.setState({
        [key]: data,
      });
    },
    // 拉取垫图列表
    async getImagePaddingList(data = {}) {
      const rst = await post('/api/image/getImagePaddingList', data);
      return rst;
    },
    // 创建垫图
    async createPaddingImage(data = {}) {
      const rst = await post('/api/image/createPaddingImage', data);
      return rst;
    },
    // 删除垫图
    async deletePaddingImage(data = {}) {
      const rst = await post('/api/image/deletePaddingImage', data);
      return rst;
    },
    // 更新垫图
    async updatePaddingImage(data = {}) {
      const rst = await post('/api/image/updatePaddingImage', data);
      return rst;
    },
    // 获取生图回流日志列表
    async getImgReflowLogList(data = {}) {
      const rst = await get('/api/image/getImgReflowLogList', data);
      return rst;
    },
  },
});
